/**
 * @param { Promise } promise
 * @return { Promise }
 */
export async function to(promise) {
    return promise
        .then((data) => [null, data])
        .catch((err) => [err, undefined]);
}
to.retry = retry;
/**
 * @param { Promise } promise
 * @param { Object= } options - Additional options
 * @return { Promise }
 */
async function retry(promiseFunction, options = {}) {
    const { retries = 2, retryDelay = 1000 } = options;
    let retryCount = 0;
    while (true) {
        try {
            const data = await promiseFunction();
            return [null, data];
        }
        catch (err) {
            if (retryCount < retries) {
                retryCount++;
                await new Promise((resolve) => setTimeout(resolve, retryDelay));
            }
            else {
                return [err, undefined];
            }
        }
    }
}
//# sourceMappingURL=to.js.map